import get from 'lodash/get';

export default filterOn => state =>
  get(state, `shops.shared.filters.${filterOn}`, null);
